/**
 * How a company was provisioned/onboarded
 * - PARTNER: Provisioned via partner API (e.g., ShowMojo)
 * - ONBOARD: Standard customer onboarding flow (human touched)
 * - SELF_SERVICE: Provisioned automatically at first WorkOS signup callback
 */
export var ProvisioningSource;
(function (ProvisioningSource) {
    ProvisioningSource["PARTNER"] = "PARTNER";
    ProvisioningSource["ONBOARD"] = "ONBOARD";
    ProvisioningSource["SELF_SERVICE"] = "SELF_SERVICE";
})(ProvisioningSource || (ProvisioningSource = {}));
//# sourceMappingURL=provisioning.js.map